import React from 'react';
import Icon from '../../../components/AppIcon';

const ValidationStatusCards = ({ statistics }) => {
  const cards = [
    {
      title: 'Total Audio Files',
      value: statistics?.totalFiles || 0,
      icon: 'Music',
      color: 'bg-blue-500',
      textColor: 'text-blue-600',
      bgLight: 'bg-blue-50'
    },
    {
      title: 'Quality Passed',
      value: statistics?.qualityPassed || 0,
      percentage: statistics?.totalFiles ? Math.round((statistics?.qualityPassed / statistics?.totalFiles) * 100) : 0,
      icon: 'CheckCircle',
      color: 'bg-green-500',
      textColor: 'text-green-600',
      bgLight: 'bg-green-50'
    },
    {
      title: 'Quality Failed',
      value: statistics?.qualityFailed || 0,
      percentage: statistics?.totalFiles ? Math.round((statistics?.qualityFailed / statistics?.totalFiles) * 100) : 0,
      icon: 'XCircle',
      color: 'bg-red-500',
      textColor: 'text-red-600',
      bgLight: 'bg-red-50'
    },
    {
      title: 'Duration Issues',
      value: statistics?.durationIssues || 0,
      icon: 'Clock',
      color: 'bg-orange-500',
      textColor: 'text-orange-600',
      bgLight: 'bg-orange-50'
    },
    {
      title: 'Upload Complete',
      value: statistics?.uploadComplete || 0,
      percentage: statistics?.totalFiles ? Math.round((statistics?.uploadComplete / statistics?.totalFiles) * 100) : 0,
      icon: 'Upload',
      color: 'bg-purple-500',
      textColor: 'text-purple-600',
      bgLight: 'bg-purple-50'
    }
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-6 mb-8">
      {cards?.map((card, index) => (
        <div key={index} className="bg-card border border-border rounded-lg p-6 hover:shadow-lg transition-all duration-200">
          <div className="flex items-start justify-between mb-4">
            <div className="flex-1">
              <p className="text-sm font-medium text-muted-foreground mb-1">{card?.title}</p>
              <h3 className="text-3xl font-bold text-card-foreground">{card?.value}</h3>
              {card?.percentage !== undefined && (
                <p className="text-sm text-muted-foreground mt-1">{card?.percentage}% of total</p>
              )}
            </div>
            <div className={`w-12 h-12 rounded-lg ${card?.color} flex items-center justify-center`}>
              <Icon name={card?.icon} size={24} className="text-white" />
            </div>
          </div>
          <div className="w-full bg-muted rounded-full h-2">
            <div 
              className={`h-2 rounded-full ${card?.color}`}
              style={{ width: `${card?.percentage || 100}%` }}
            />
          </div>
        </div>
      ))}
    </div>
  );
};

export default ValidationStatusCards;
